<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$tc("m.BT_" + betType, 2) + " " + $t("ui.esports2")')
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.member_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="member_id"
                    :placeholder='$t("ui.member_id")'
                    v-model="member_id"
                    size="sm"
                    @keyup.enter.native="submit"
                  )
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.timer')" size="sm")
                  b-form-select(
                    ref="refresh"
                    v-model="refresh"
                    :options="refreshOptions"
                    size="sm"
                    :disabled="loading"
                    @change="refreshTimer"
                  )
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-6.col-lg-6.col-xl-2
                SubmitButton(:loading="loading" icon="fa fa-sync" :text="$t('ui.refresh') + (refresh > 0 ? ' (' +  timer + ' ' + $t('ui.seconds') + ')' : '')" isModal=false type="button" @click="search")
            b-row
              .col-sm-12.col-md-8.col-lg-9.col-xl-10.mb-1
                b-pagination(size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @input="search")
              .col-sm-12.col-md-4.col-lg-3.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="perPage" @input="changedPageSize")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="betList" :fields="fields" :per-page="perPage" :filter="filter")
                  template(v-slot:cell(index)="row")
                    span {{ row.index + 1 }}
                  template(v-slot:cell(settlement_datetime)="row")
                    span {{ $moment(row.item.settlement_datetime).format("YYYY-MM-DD HH:mm:ss") }}
                    br
                    span #[b {{ row.item.bet_id }}]
                    br
                    span {{ row.item.client_ip }}
                  template(v-slot:cell(member_id)="row")
                    span {{ row.item.member_id.toUpperCase() }}
                  template(v-slot:cell(event)="row")
                    span.badge.bg-blue-darker {{ row.item.event_id }}
                    br
                    template(v-if="!row.item.is_combo")
                      span.mr-1 #[b {{ row.item.game_type_name }}] ({{ row.item.game_market_name }})
                      br
                      span {{ row.item.competition_name }}
                      br
                      span {{ row.item.event_name }}
                      br
                    span {{ $moment(row.item.event_datetime).format("YYYY-MM-DD HH:mm:ss") }}
                  template(v-slot:cell(detail)="row")
                    template(v-if="!row.item.is_combo")
                      span.label.bg-black {{ row.item.bet_type_name }}
                      br
                      //- span(v-if="row.item.event_name") {{ row.item.bet_selection == 'home' ? row.item.event_name.split('vs')[0].toString() : row.item.event_name.split('vs')[1].toString() }}
                      //- br
                      span.text-capitalize {{ row.item.bet_selection }} @ {{ row.item.member_odds }}
                    template(v-else)
                      span.label.bg-black COMBO
                      br
                      span @ {{ row.item.member_odds }}
                      br
                      span.label.bg-black {{ $t("ui.details") }}
                      i.fa.ml-1(size="sm" @click.stop="row.toggleDetails" @click="getEsports2Combo(row.item)" :class="row.detailsShowing ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                  template(v-slot:row-details="row")
                    b-table#innerTable.table-sm(show-empty :items="esports2Combo" :fields="es2fields")
                      template(v-slot:cell(index)="row")
                        span {{ row.index + 1 }}
                      template(v-slot:cell(event_datetime)="row")
                        span {{ $moment(row.item.event_datetime).format("YYYY-MM-DD") }}
                      template(v-slot:cell(home_team_name)="row")
                        span(v-if="row.item.event_name") {{ row.item.event_name.split("vs")[0].toString() }}
                      template(v-slot:cell(away_team_name)="row")
                        span(v-if="row.item.event_name") {{ row.item.event_name.split("vs")[1].toString() }}
                      template(v-slot:cell(bet)="row")
                        span(v-if="row.item.bet_selection") {{ row.item.bet_selection == 'home' ? row.item.event_name.split("vs")[0].toString() : row.item.event_name.split("vs")[1].toString() }}
                  template(v-slot:cell(bet_amount)="row")
                    span(:class="$helpers.getNumberClass(row.item.bet_amount)") #[b {{ row.item.bet_amount | currency }} ]
</template>

<script>
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput"

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  props: {
    betType: {
      type: String,
      default: "ALL"
    }
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      betList: [],
      esports2Combo: [],
      refreshOptions: [
        { value: 0, text: this.$t("ui.no_refresh") },
        { value: 15, text: 15 + ' ' + this.$t("ui.seconds") },
        { value: 30, text: 30 + ' ' + this.$t("ui.seconds") },
        { value: 45, text: 45 + ' ' + this.$t("ui.seconds") },
        { value: 60, text: 60 + ' ' + this.$t("ui.seconds") }
      ],
      member_id: this.$store.getters.getSelectedID == this.$store.getters.accountID ? "" : this.$store.getters.getSelectedID,
      filter: null,
      sortBy: "date_created",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0,
      countdown: null,
      timer: 60,
      refresh: 0
    };
  },
  validations: {},
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "member_id",
          label: this.$t("ui.member_id"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "settlement_datetime",
          label: this.$t("ui.date_time"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "15%"
          }
        },
        {
          key: "event",
          label: this.$t("ui.event"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "25%"
          }
        },
        {
          key: "detail",
          label: this.$t("ui.detail"),
          class: "align-middle text-left",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "bet_amount",
          label: this.$t("ui.amount"),
          class: "align-middle text-right",
          thClass: "align-middle bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        }
      ]
    },
    es2fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "align-middle bg-dark-lighter text-white"
        },
        {
          key: "event_datetime",
          label: this.$t("ui.date"),
          thClass: "bg-dark-lighter text-white"
        },
        {
          key: "competition_name",
          label: this.$t("ui.league_name"),
          thClass: "bg-dark-lighter text-white"
        },
        {
          key: "home_team_name",
          label: this.$t("ui.home_team_name"),
          thClass: "bg-dark-lighter text-white"
        },
        {
          key: "away_team_name",
          label: this.$t("ui.away_team_name"),
          thClass: "bg-dark-lighter text-white"
        },
        {
          key: "bet_type_name",
          label: this.$t("ui.bet_type"),
          thClass: "bg-dark-lighter text-white",
          class: "text-center"
        },
        {
          key: "bet",
          label: this.$t("ui.bet"),
          thClass: "bg-dark-lighter text-white",
        },
        {
          key: "member_odds",
          label: this.$t("ui.odds_display"),
          thClass: "bg-dark-lighter text-white",
          class: "text-center"
        },
        // {
        //   key: "result",
        //   label: this.$t("ui.result"),
        //   thClass: "bg-dark-lighter text-white",
        //   class: "text-center"
        // },
        // {
        //   key: "result_status",
        //   label: this.$t("ui.status"),
        //   thClass: "bg-dark-lighter text-white",
        //   class: "align-middle text-center"
        // }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  mounted: function() {
    this.search()
    this.countdown = setInterval(() => {
      if(this.refresh > 0) {
        if(this.timer > 0) {
          this.timer -= 1
        } else {
          this.timer = this.refresh
          this.search()
        }
      }
    }, 1 * 1000)
  },
  beforeDestroy: function() {
    clearInterval(this.countdown)
  },
  methods: {
    refreshTimer() {
      this.timer = this.refresh
      this.search()
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.search()
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.search()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    },
    search: function() {
      if (!this.$v.$invalid) {
        let member_id = this.member_id
        let page_number = this.currentPage
        this.currentPage = parseInt(page_number)
        let page_size = this.perPage
        let sort_key = this.sortBy
        let sort_type = this.direction
        this.loading = true
        this.$store
          .dispatch("user/getActiveBetlistESports2", { member_id, page_number, page_size, sort_key, sort_type })
          .then(response => {
            this.totalRows = 0
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              if(response.data.length > 0) {
                this.betList = response.data
                this.totalRows = response.data.length > 0 ? this.betList[0]["totalrows"] : 0
              } else {
                this.betList = []
                this.totalRows = 0
              }
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
            }
          })
          .catch(response => {
            this.loading = false
            this.betList = []
            this.totalRows = 0
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    },
    getEsports2Combo: function(item) {
      this.esports2Combo = [];
      if (item._showDetails) {
        this.betList.forEach(value => {
          this.$set(value, "_showDetails", false);
        });
        this.$set(item, "_showDetails", true);
      }
      let bet_id = item.bet_id;
      this.$store
        .dispatch("user/getBetListEsportsDetailCombo", { bet_id })
        .then(response => {
          // console.log("Response: ", response);
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = response.errorTag;
          if (this.submission.success == true) {
            if (response.data.length > 0) {
              this.esports2Combo = response.data;
            }
          } else {
            this.loading = false;
            this.submission.success = response.success;
            this.submission.status = response.errorTag;
          }
        })
        .catch(response => {
          // console.log("Response: ", response);
          this.loading = false;
          this.submission.success = response.success;
          this.submission.status = this.$t("message." + response.errorTag);
        });
    },
  }
};
</script>